module.exports = __webpack_public_path__ + "img/6.21b5da4d.png";